<template>
  <div class="home-container">
    <!-- 顶部导航（可根据系统需求扩展） -->
    <!-- <el-header class="header">
      <el-row align="middle">
        <el-col :span="12">
          <h1 class="system-title">江西企业管理系统</h1>
        </el-col>
        <el-col :span="12" class="header-actions">
          <el-button type="text">数据概览</el-button>
          <el-button type="text">系统设置</el-button>
        </el-col>
      </el-row>
    </el-header> -->

    <!-- 主体内容：地图+统计数据 -->
    <!-- <el-main class="main-content"> -->
      <el-row :gutter="20">
        <!-- 左侧统计数据卡片（4个统计项） -->
        <el-col :span="6" class="stats-col">
          <el-card class="stats-card" v-for="(item, index) in statsData" :key="index">
            <div class="stats-item">
              <span class="stats-label">{{ item.label }}</span>
              <span class="stats-value">{{ item.value }}</span>
              <span class="stats-unit">{{ item.unit }}</span>
            </div>
          </el-card>
        </el-col>

        <!-- 中间地图容器（核心区域） -->
        <el-col :span="12" class="map-col">
          <el-card class="map-card">
            <div class="map-title">宜春市企业分布地图</div>
            <div id="jiangxi-map" class="map-container"></div>
          </el-card>
        </el-col>

        <!-- 右侧统计数据卡片（2个统计项） -->
        <el-col :span="6" class="stats-col">
          <el-card class="stats-card" v-for="(item, index) in extraStatsData" :key="index">
            <div class="stats-item">
              <span class="stats-label">{{ item.label }}</span>
              <span class="stats-value">{{ item.value }}</span>
              <span class="stats-unit">{{ item.unit }}</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
    <!-- </el-main> -->

    <!-- 底部版权信息 -->
    <!-- <el-footer class="footer">
      <p>© 2026 宜春市邮政管理局 版权所有</p>
    </el-footer> -->

  </div>
</template>

<script>
import * as echarts from 'echarts'
// 引入江西省地图JSON数据（需自行下载或通过CDN引入）
import yichunJson from '@/assets/map/yichun.json'

export default {
  name: 'HomePage',
  data() {
    return {
      // 核心统计数据
      statsData: [
        { label: '企业总数', value: 1258, unit: '家' },
        { label: '企业人员总数', value: 86420, unit: '人' },
        { label: '规上企业数', value: 326, unit: '家' },
        { label: '高新技术企业', value: 158, unit: '家' }
      ],
      // 额外统计数据
      extraStatsData: [
        { label: '年营收总额', value: 468.5, unit: '亿元' },
        { label: '纳税总额', value: 32.8, unit: '亿元' }
      ],
      mapChart: null
    }
  },
  mounted() {
	// 强制设置容器宽高（关键！）
	const mapDom = document.getElementById('jiangxi-map')
	mapDom.style.width = '100%'
	mapDom.style.height = '600px' // 固定高度，优先保证渲染

    this.initMap()
  },
  beforeDestroy() {
    if (this.mapChart) {
      this.mapChart.dispose()
    }
  },
  methods: {
    // 初始化江西地图
    initMap() {
      // 注册地图
      echarts.registerMap('yichun', yichunJson)
      // 初始化图表
      this.mapChart = echarts.init(document.getElementById('jiangxi-map'))
      // 配置项
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c}',
          textStyle: { fontSize: 12 }
        },
        visualMap: {
          show: false,
          min: 0,
          max: 2000,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],
          calculable: true,
          seriesIndex: [0]
        },
        series: [
          {
            name: '企业数量',
            type: 'map',
            mapType: 'yichun',
            roam: false, // 禁止缩放和平移
            label: {
              show: true, // 显示名称
              fontSize: 10,
              color: '#333'			  
            },
            emphasis: {
              label: {
                color: '#fff',
                fontSize: 12
              },
              itemStyle: {
                areaColor: '#4e79a7'
              }
            },
            data: [
              { name: '袁州区', value: 286, itemStyle: { areaColor: '#ff4d4f' } },
              { name: '奉新县', value: 286, itemStyle: { areaColor: '#ff4d4f' } },
              { name: '万载县', value: 286, itemStyle: { areaColor: '#ff4d4f' } },
              { name: '上高县', value: 286, itemStyle: { areaColor: '#ff4d4f' }  },
              { name: '宜丰县', value: 286, itemStyle: { areaColor: '#ff4d4f' }  },
              { name: '靖安县', value: 286, itemStyle: { areaColor: '#ff4d4f' } },
              { name: '铜鼓县', value: 286, itemStyle: { areaColor: '#ff4d4f' }  },
              { name: '丰城市', value: 286, itemStyle: { areaColor: '#ff4d4f' }  },
              { name: '樟树市', value: 286, itemStyle: { areaColor: '#ff4d4f' }  },
              { name: '高安市', value: 286, itemStyle: { areaColor: '#ff4d4f' }  },
            ]
          }
        ]
      }
      // 渲染地图
      this.mapChart.setOption(option)
      // 自适应窗口大小
      window.addEventListener('resize', () => {
        this.mapChart.resize()
      })
    }
  }
}
</script>

<style scoped>
/* 全局容器样式 */
.home-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 顶部导航 */
.header {
  background-color: #2e6da4;
  color: #fff;
  padding: 0 20px;
}
.system-title {
  font-size: 20px;
  margin: 0;
}
.header-actions {
  text-align: right;
}
.header-actions el-button {
  color: #fff;
}

/* 主体内容 */
.main-content {
  flex: 1;
  padding: 20px;
  background-color: #f5f5f5;
}

/* 统计数据列 */
.stats-col {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.stats-card {
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.stats-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.stats-label {
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}
.stats-value {
  font-size: 28px;
  font-weight: bold;
  color: #2e6da4;
}
.stats-unit {
  font-size: 14px;
  color: #999;
  margin-left: 5px;
}

/* 地图列 */
.map-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
.map-card {
  width: 100%;
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.map-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
  border-bottom: 1px solid #e6e6e6;
}
.map-container {
  width: 100%;
  height: calc(100% - 40px);
}

/* 底部版权 */
.footer {
  text-align: center;
  padding: 10px 0;
  background-color: #f5f5f5;
  color: #666;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// Main.vue?603b6fe2